<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
}
</script>
<style lang="scss">
html,body{
  height:100%;
}
#app {
  height: 100%;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

</style>
